import React, { useEffect, useState, useCallback } from "react";

export const Checkbox = ({
  checked,
  onCheckedChange,
  variant = "default",
  size = "md",
  className = "",
  disabled = false,
  id,
  "aria-label": ariaLabel,
}) => {
  const isControlled = typeof checked !== "undefined";
  const [internalChecked, setInternalChecked] = useState(!!checked);

  useEffect(() => {
    if (isControlled) setInternalChecked(checked === "indeterminate" ? false : !!checked);
  }, [checked, isControlled]);

  const handleToggle = useCallback(() => {
    if (disabled) return;
    const next = !internalChecked;
    if (!isControlled) setInternalChecked(next);
    onCheckedChange && onCheckedChange(next);
  }, [disabled, internalChecked, onCheckedChange, isControlled]);

  const sizeClasses = size === "sm" ? "w-4 h-4" : size === "lg" ? "w-6 h-6" : "w-5 h-5";
  const baseVariant = variant === "outline" ? "bg-transparent" : "bg-white/5";
  const stateClasses = internalChecked ? "bg-white border-white text-black" : `${baseVariant} border-white/40 text-white`;

  return (
    <button
      type="button"
      id={id}
      aria-label={ariaLabel}
      role="checkbox"
      aria-checked={checked === "indeterminate" ? "mixed" : internalChecked}
      onClick={handleToggle}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          handleToggle();
        }
      }}
      disabled={disabled}
      tabIndex={0}
      className={`inline-flex items-center justify-center rounded-sm border ${sizeClasses} ${stateClasses} transition-colors focus:outline-none focus:ring-2 focus:ring-white/40 disabled:opacity-50 ${className}`}
    >
      {checked === "indeterminate" ? (
        <span className={`block w-3/5 h-0.5 ${internalChecked ? 'bg-black' : 'bg-white'}`} />
      ) : internalChecked ? (
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6667 5.83331L8.33333 14.1666L3.33333 9.16665" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ) : null}
    </button>
  );
};

export const type = {};


